import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../actions/';
import App from '../components/app';




const mapStateToProps = (state, ownProps) => {
 
    return state;
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        
        getNacionalidade(){
            dispatch(actions.getNacionalidade());
        },
        handleChangeAba: function(e, index){
            dispatch(actions.setAba(index));
        }
    };
};

const AppContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(App);


export default AppContainer;


// WEBPACK FOOTER //
// ./src/containers/app.js